import { useRouteMatch } from 'react-router-dom';
import { sanitizePath } from 'router/utils';

export const useBasepath = () => {
    const { path } = useRouteMatch();
    const basepath = sanitizePath(path);
    return { basepath };
};
